import { useEffect, useRef, useState } from "react";

function getToken() {
  return localStorage.getItem("ls");
}

function isTokenExpired(token) {
  try {

    const payload = JSON.parse(token);
    const expiration = new Date(payload.login.expiration)
    const today = new Date()
    if (expiration < today) return true;    
    return false;
  } catch {
    return true; // invalid token
  }
}



export function useSessionWatcher({
  idleTimeout,
  onSessionExpired,
}) {
  const [isIdle, setIsIdle] = useState(false);
  const idleTimer = useRef(null);

  const resetIdleTimer = () => {
    if (idleTimer.current) clearTimeout(idleTimer.current);
    setIsIdle(false);
    idleTimer.current = setTimeout(() => setIsIdle(true), idleTimeout);
  };

  useEffect(() => {
    // 🧍‍♂️ Detect user activity
    const activityEvents = ["mousemove", "keydown", "scroll", "click"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetIdleTimer)
    );

    resetIdleTimer(); // start timer immediately

    const checkInterval = setInterval(() => {
      const token = getToken();
      if (!token || isTokenExpired(token)) {
        onSessionExpired();
      }
    }, 10 * 1000); // check token every 30s

    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
      if (idleTimer.current) clearTimeout(idleTimer.current);
      clearInterval(checkInterval);
    };
  }, [idleTimeout, onSessionExpired]);

  useEffect(() => {
    if (isIdle) {
      onSessionExpired();
    }
  }, [isIdle, onSessionExpired]);
}

